export enum BarcodeScannerTypes {
  Community = 'Community',
  Paymash = 'Paymash',
}
